import { Component, Input, Output, EventEmitter } from '@angular/core'

import { Screen } from '../../../data/models'
import { IScreenComponent } from '../../../angular/components/exam-screen/'

@Component({
  selector: 'mp-default-screen',
  templateUrl: './default-screen.html',
  styleUrls: ['./default-screen.scss']
})
export class DefaultScreenComponent implements IScreenComponent {
    @Input() public screen: Screen
    @Output() public onUiChangesRequested: EventEmitter<any> = new EventEmitter<any>()
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/default-screen/default-screen.component.ts